import { StaticImage } from 'gatsby-plugin-image'
import React, { Component } from 'react'
import Button from '../../ui/Button'
import *as s from './Hero.module.css'

export default class Hero extends Component {
    render() {
        return (
            <div className={s.wrapper}>
                <div className={s.content}>
                    <div className={s.textBlok}> 
                        <h1 className={s.headline}>
                            Unser Service Ihre Lösung
                        </h1>
                        <p className={s.text}>
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus at magni quaerat consequuntur
                            dolores sint consectetur.
                            Minus aliquam corporis maiores eum repellendus illum.
                        </p>
                    </div>
                    <StaticImage className={s.illustration} src="../../../images/hero.jpg" alt="illustration"/>
                </div>
                <Button buttonText="start"/>
            </div>
        )
    }
}
